// API Configuration with hardcoded server values
export const getApiConfig = () => {
  // Hardcoded server configuration for production
  const SERVER_IP = '20.242.121.99';
  const SERVER_PORT = '8082';
  const SERVER_DNS = 'realtravelapp.com'
  
  return {
    API_URL: `https://${SERVER_DNS}`,
    BASE_URL: `http://${SERVER_DNS}`,
    SERVER_IP: SERVER_IP
  };
};

// Export individual config values for convenience
export const { API_URL, BASE_URL, SERVER_IP } = getApiConfig(); 
